<template>
	<header class="header">
		<TopNavbar />
		<div class="menu">
			<div class="container">
				<nav class="menu" aria-label="menu">
					<!-- LOGO -->
					<a href="/" class="logo">
						<h1>
							<img alt="Moisson logo" src="~@/assets/img/logo.png" />
						</h1>
					</a>
					<div class="menu-container">
						<div class="main-menu">
							<div class="main-menu-options">
								<ul role="menu">
									<template v-for="(link, index) in links">
										<Link
											v-if="index != 'lang'"
											:key="index"
											:title="link.title"
											:url="link.url"
											:target="link.target"
											:className="index"
										/>
										<LangLink v-else :link="link" :key="index" />
									</template>
								</ul>
							</div>
						</div>
					</div>
					<a
						href="#"
						class="to-open-close-menu-mobile"
						aria-expanded="false"
						aria-controls="menu"
						aria-label="Navigation"
						@click="openMenuMobile"
					>
						<i>
							<span class="auxiliar"></span>
						</i>
						<span class="srt to-open">Open Menu Mobile</span>
						<span class="srt to-close">Close Menu Mobile</span>
					</a>
				</nav>
			</div>
		</div>
	</header>
</template>

<script>
import TopNavbar from '../partials/TopNavbar.vue'
import Link from '../partials/Link.vue'
import LangLink from '../partials/LangLink.vue'
export default {
	name: 'navBar',
	components: { Link, TopNavbar, LangLink },
	methods: {
		openMenuMobile() {
			var $body = document.getElementsByTagName('body')[0]

			if ($body.classList.contains('menu-open')) {
				$body.classList.remove('menu-open')
			} else {
				$body.classList.add('menu-open')
			}
		},
	},

	computed: {
		links() {
			//Get Navbar links from translations
			return this.$t('Navbar')
		},
	},
	created() {
		window.addEventListener('scroll', this.handleScroll)
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
	@include box-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}
.lang {
	display: none;
}

@include collapsed {
	.lang {
		display: block;
	}
}
</style>
